import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _5b94f450 = () => interopDefault(import('..\\..\\..\\pages\\about.vue' /* webpackChunkName: "pages/about" */))
const _c5a76fa6 = () => interopDefault(import('..\\..\\..\\pages\\cleverLogin.vue' /* webpackChunkName: "pages/cleverLogin" */))
const _1d68442b = () => interopDefault(import('..\\..\\..\\pages\\contact.vue' /* webpackChunkName: "pages/contact" */))
const _1c253ec6 = () => interopDefault(import('..\\..\\..\\pages\\index.vue' /* webpackChunkName: "pages/index" */))
const _ff0c7b72 = () => interopDefault(import('..\\..\\..\\pages\\educators\\index.vue' /* webpackChunkName: "pages/educators/index" */))
const _35b37ed3 = () => interopDefault(import('..\\..\\..\\pages\\error.vue' /* webpackChunkName: "pages/error" */))
const _e1993d7c = () => interopDefault(import('..\\..\\..\\pages\\features.vue' /* webpackChunkName: "pages/features" */))
const _02408ffa = () => interopDefault(import('..\\..\\..\\pages\\getting-started.vue' /* webpackChunkName: "pages/getting-started" */))
const _2534f4fc = () => interopDefault(import('..\\..\\..\\pages\\lessons\\index.vue' /* webpackChunkName: "pages/lessons/index" */))
const _9a110364 = () => interopDefault(import('..\\..\\..\\pages\\login\\index.vue' /* webpackChunkName: "pages/login/index" */))
const _041c7b4f = () => interopDefault(import('..\\..\\..\\pages\\logout.vue' /* webpackChunkName: "pages/logout" */))
const _7c26229a = () => interopDefault(import('..\\..\\..\\pages\\notifications.vue' /* webpackChunkName: "pages/notifications" */))
const _6c2bce06 = () => interopDefault(import('..\\..\\..\\pages\\pathfinders-summer-pd-2025.vue' /* webpackChunkName: "pages/pathfinders-summer-pd-2025" */))
const _a0fd4ea6 = () => interopDefault(import('..\\..\\..\\pages\\plans\\index.vue' /* webpackChunkName: "pages/plans/index" */))
const _5b6d18a3 = () => interopDefault(import('..\\..\\..\\pages\\projects\\index.vue' /* webpackChunkName: "pages/projects/index" */))
const _6caadd72 = () => interopDefault(import('..\\..\\..\\pages\\quote.vue' /* webpackChunkName: "pages/quote" */))
const _7ec28d61 = () => interopDefault(import('..\\..\\..\\pages\\redirect.vue' /* webpackChunkName: "pages/redirect" */))
const _359a9aa2 = () => interopDefault(import('..\\..\\..\\pages\\schools-districts.vue' /* webpackChunkName: "pages/schools-districts" */))
const _65eed628 = () => interopDefault(import('..\\..\\..\\pages\\settings.vue' /* webpackChunkName: "pages/settings" */))
const _df505bf6 = () => interopDefault(import('..\\..\\..\\pages\\signup\\index.vue' /* webpackChunkName: "pages/signup/index" */))
const _231c5687 = () => interopDefault(import('..\\..\\..\\pages\\studio\\index.vue' /* webpackChunkName: "pages/studio/index" */))
const _056e7b68 = () => interopDefault(import('..\\..\\..\\pages\\what-is-visual-coding.vue' /* webpackChunkName: "pages/what-is-visual-coding" */))
const _6bd7494e = () => interopDefault(import('..\\..\\..\\pages\\why-creative-coding.vue' /* webpackChunkName: "pages/why-creative-coding" */))
const _69b500c7 = () => interopDefault(import('..\\..\\..\\pages\\account\\confirm-email.vue' /* webpackChunkName: "pages/account/confirm-email" */))
const _50d16328 = () => interopDefault(import('..\\..\\..\\pages\\account\\password-change\\index.vue' /* webpackChunkName: "pages/account/password-change/index" */))
const _07061c11 = () => interopDefault(import('..\\..\\..\\pages\\account\\reset-password.vue' /* webpackChunkName: "pages/account/reset-password" */))
const _6a09bb98 = () => interopDefault(import('..\\..\\..\\pages\\account\\social-redirect.vue' /* webpackChunkName: "pages/account/social-redirect" */))
const _433ea935 = () => interopDefault(import('..\\..\\..\\pages\\classes\\select\\index.vue' /* webpackChunkName: "pages/classes/select/index" */))
const _98ac3512 = () => interopDefault(import('..\\..\\..\\pages\\educators\\ambassadors.vue' /* webpackChunkName: "pages/educators/ambassadors" */))
const _03adb5cb = () => interopDefault(import('..\\..\\..\\pages\\educators\\faq.vue' /* webpackChunkName: "pages/educators/faq" */))
const _fa6580cc = () => interopDefault(import('..\\..\\..\\pages\\educators\\resources.vue' /* webpackChunkName: "pages/educators/resources" */))
const _e23b289c = () => interopDefault(import('..\\..\\..\\pages\\lessons\\edit\\index.vue' /* webpackChunkName: "pages/lessons/edit/index" */))
const _625296d5 = () => interopDefault(import('..\\..\\..\\pages\\login\\qr.vue' /* webpackChunkName: "pages/login/qr" */))
const _6964bbf4 = () => interopDefault(import('..\\..\\..\\pages\\plans\\educator_monthly.vue' /* webpackChunkName: "pages/plans/educator_monthly" */))
const _1211c082 = () => interopDefault(import('..\\..\\..\\pages\\plans\\educator_plus_monthly.vue' /* webpackChunkName: "pages/plans/educator_plus_monthly" */))
const _d7655d70 = () => interopDefault(import('..\\..\\..\\pages\\plans\\educator_plus_yearly.vue' /* webpackChunkName: "pages/plans/educator_plus_yearly" */))
const _2789ea21 = () => interopDefault(import('..\\..\\..\\pages\\plans\\educator_yearly.vue' /* webpackChunkName: "pages/plans/educator_yearly" */))
const _1f6acd21 = () => interopDefault(import('..\\..\\..\\pages\\policy\\privacy.vue' /* webpackChunkName: "pages/policy/privacy" */))
const _69bfa7e0 = () => interopDefault(import('..\\..\\..\\pages\\policy\\terms.vue' /* webpackChunkName: "pages/policy/terms" */))
const _2acaf512 = () => interopDefault(import('..\\..\\..\\pages\\policy\\third-parties.vue' /* webpackChunkName: "pages/policy/third-parties" */))
const _c97e1db6 = () => interopDefault(import('..\\..\\..\\pages\\signup\\classlink.vue' /* webpackChunkName: "pages/signup/classlink" */))
const _66bd7be4 = () => interopDefault(import('..\\..\\..\\pages\\signup\\clever.vue' /* webpackChunkName: "pages/signup/clever" */))
const _4750f96e = () => interopDefault(import('..\\..\\..\\pages\\signup\\teachers.vue' /* webpackChunkName: "pages/signup/teachers" */))
const _4f229994 = () => interopDefault(import('..\\..\\..\\pages\\account\\password-change\\_token.vue' /* webpackChunkName: "pages/account/password-change/_token" */))
const _418807ed = () => interopDefault(import('..\\..\\..\\pages\\classes\\select\\_slug.vue' /* webpackChunkName: "pages/classes/select/_slug" */))
const _e5a86b2c = () => interopDefault(import('..\\..\\..\\pages\\lessons\\edit\\_slug.vue' /* webpackChunkName: "pages/lessons/edit/_slug" */))
const _43edb2ae = () => interopDefault(import('..\\..\\..\\pages\\lessons\\page\\_page.vue' /* webpackChunkName: "pages/lessons/page/_page" */))
const _7780c890 = () => interopDefault(import('..\\..\\..\\pages\\lessons\\select\\_slug.vue' /* webpackChunkName: "pages/lessons/select/_slug" */))
const _f2e89de0 = () => interopDefault(import('..\\..\\..\\pages\\projects\\page\\_page.vue' /* webpackChunkName: "pages/projects/page/_page" */))
const _374897b5 = () => interopDefault(import('..\\..\\..\\pages\\studio\\edit\\_slug.vue' /* webpackChunkName: "pages/studio/edit/_slug" */))
const _35dc2eed = () => interopDefault(import('..\\..\\..\\pages\\classes\\_classSlug\\index.vue' /* webpackChunkName: "pages/classes/_classSlug/index" */))
const _6aba546e = () => interopDefault(import('..\\..\\..\\pages\\invite\\_code.vue' /* webpackChunkName: "pages/invite/_code" */))
const _237e53b4 = () => interopDefault(import('..\\..\\..\\pages\\lessons\\_slug.vue' /* webpackChunkName: "pages/lessons/_slug" */))
const _39e5d60a = () => interopDefault(import('..\\..\\..\\pages\\pay\\_slug\\index.vue' /* webpackChunkName: "pages/pay/_slug/index" */))
const _08c2f0c7 = () => interopDefault(import('..\\..\\..\\pages\\projects\\_slug\\index.vue' /* webpackChunkName: "pages/projects/_slug/index" */))
const _16245428 = () => interopDefault(import('..\\..\\..\\pages\\classes\\_classSlug\\about.vue' /* webpackChunkName: "pages/classes/_classSlug/about" */))
const _9dc62666 = () => interopDefault(import('..\\..\\..\\pages\\classes\\_classSlug\\students.vue' /* webpackChunkName: "pages/classes/_classSlug/students" */))
const _362c8964 = () => interopDefault(import('..\\..\\..\\pages\\projects\\_slug\\embed.vue' /* webpackChunkName: "pages/projects/_slug/embed" */))
const _496ac138 = () => interopDefault(import('..\\..\\..\\pages\\classes\\_classSlug\\lessons\\_slug.vue' /* webpackChunkName: "pages/classes/_classSlug/lessons/_slug" */))
const _cf118ff6 = () => interopDefault(import('..\\..\\..\\pages\\qr\\_token\\_username.vue' /* webpackChunkName: "pages/qr/_token/_username" */))
const _44533d82 = () => interopDefault(import('..\\..\\..\\pages\\_username\\index.vue' /* webpackChunkName: "pages/_username/index" */))
const _249b62bd = () => interopDefault(import('..\\..\\..\\pages\\_username\\about.vue' /* webpackChunkName: "pages/_username/about" */))
const _1ed732fa = () => interopDefault(import('..\\..\\..\\pages\\_username\\stories.vue' /* webpackChunkName: "pages/_username/stories" */))
const _664625d0 = () => interopDefault(import('..\\..\\..\\pages\\_username\\art\\%_slug.vue' /* webpackChunkName: "pages/_username/art/%_slug" */))
const _62d8e340 = () => interopDefault(import('..\\..\\..\\pages\\_username\\art\\%index.vue' /* webpackChunkName: "pages/_username/art/%index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/about/",
    component: _5b94f450,
    pathToRegexpOptions: {"strict":true},
    name: "about___en"
  }, {
    path: "/cleverLogin/",
    component: _c5a76fa6,
    pathToRegexpOptions: {"strict":true},
    name: "cleverLogin"
  }, {
    path: "/contact/",
    component: _1d68442b,
    pathToRegexpOptions: {"strict":true},
    name: "contact___en"
  }, {
    path: "/de/",
    component: _1c253ec6,
    pathToRegexpOptions: {"strict":true},
    name: "index___de"
  }, {
    path: "/educators/",
    component: _ff0c7b72,
    pathToRegexpOptions: {"strict":true},
    name: "educators___en"
  }, {
    path: "/el/",
    component: _1c253ec6,
    pathToRegexpOptions: {"strict":true},
    name: "index___el"
  }, {
    path: "/error/",
    component: _35b37ed3,
    pathToRegexpOptions: {"strict":true},
    name: "error___en"
  }, {
    path: "/es/",
    component: _1c253ec6,
    pathToRegexpOptions: {"strict":true},
    name: "index___es"
  }, {
    path: "/features/",
    component: _e1993d7c,
    pathToRegexpOptions: {"strict":true},
    name: "features___en"
  }, {
    path: "/fr/",
    component: _1c253ec6,
    pathToRegexpOptions: {"strict":true},
    name: "index___fr"
  }, {
    path: "/getting-started/",
    component: _02408ffa,
    pathToRegexpOptions: {"strict":true},
    name: "getting-started___en"
  }, {
    path: "/it/",
    component: _1c253ec6,
    pathToRegexpOptions: {"strict":true},
    name: "index___it"
  }, {
    path: "/lessons/",
    component: _2534f4fc,
    pathToRegexpOptions: {"strict":true},
    name: "lessons___en"
  }, {
    path: "/login/",
    component: _9a110364,
    pathToRegexpOptions: {"strict":true},
    name: "login___en"
  }, {
    path: "/logout/",
    component: _041c7b4f,
    pathToRegexpOptions: {"strict":true},
    name: "logout"
  }, {
    path: "/notifications/",
    component: _7c26229a,
    pathToRegexpOptions: {"strict":true},
    name: "notifications___en"
  }, {
    path: "/pathfinders-summer-pd-2025/",
    component: _6c2bce06,
    pathToRegexpOptions: {"strict":true},
    name: "pathfinders-summer-pd-2025"
  }, {
    path: "/plans/",
    component: _a0fd4ea6,
    pathToRegexpOptions: {"strict":true},
    name: "plans___en"
  }, {
    path: "/projects/",
    component: _5b6d18a3,
    pathToRegexpOptions: {"strict":true},
    name: "projects___en"
  }, {
    path: "/pt_PT/",
    component: _1c253ec6,
    pathToRegexpOptions: {"strict":true},
    name: "index___pt_PT"
  }, {
    path: "/quote/",
    component: _6caadd72,
    pathToRegexpOptions: {"strict":true},
    name: "quote___en"
  }, {
    path: "/redirect/",
    component: _7ec28d61,
    pathToRegexpOptions: {"strict":true},
    name: "redirect"
  }, {
    path: "/schools-districts/",
    component: _359a9aa2,
    pathToRegexpOptions: {"strict":true},
    name: "schools-districts___en"
  }, {
    path: "/settings/",
    component: _65eed628,
    pathToRegexpOptions: {"strict":true},
    name: "settings___en"
  }, {
    path: "/signup/",
    component: _df505bf6,
    pathToRegexpOptions: {"strict":true},
    name: "signup___en"
  }, {
    path: "/studio/",
    component: _231c5687,
    pathToRegexpOptions: {"strict":true},
    name: "studio___en"
  }, {
    path: "/what-is-visual-coding/",
    component: _056e7b68,
    pathToRegexpOptions: {"strict":true},
    name: "what-is-visual-coding___en"
  }, {
    path: "/why-creative-coding/",
    component: _6bd7494e,
    pathToRegexpOptions: {"strict":true},
    name: "why-creative-coding___en"
  }, {
    path: "/account/confirm-email/",
    component: _69b500c7,
    pathToRegexpOptions: {"strict":true},
    name: "account-confirm-email___en"
  }, {
    path: "/account/password-change/",
    component: _50d16328,
    pathToRegexpOptions: {"strict":true},
    name: "account-password-change___en"
  }, {
    path: "/account/reset-password/",
    component: _07061c11,
    pathToRegexpOptions: {"strict":true},
    name: "account-reset-password___en"
  }, {
    path: "/account/social-redirect/",
    component: _6a09bb98,
    pathToRegexpOptions: {"strict":true},
    name: "account-social-redirect"
  }, {
    path: "/classes/select/",
    component: _433ea935,
    pathToRegexpOptions: {"strict":true},
    name: "classes-select___en"
  }, {
    path: "/de/about/",
    component: _5b94f450,
    pathToRegexpOptions: {"strict":true},
    name: "about___de"
  }, {
    path: "/de/contact/",
    component: _1d68442b,
    pathToRegexpOptions: {"strict":true},
    name: "contact___de"
  }, {
    path: "/de/educators/",
    component: _ff0c7b72,
    pathToRegexpOptions: {"strict":true},
    name: "educators___de"
  }, {
    path: "/de/error/",
    component: _35b37ed3,
    pathToRegexpOptions: {"strict":true},
    name: "error___de"
  }, {
    path: "/de/features/",
    component: _e1993d7c,
    pathToRegexpOptions: {"strict":true},
    name: "features___de"
  }, {
    path: "/de/getting-started/",
    component: _02408ffa,
    pathToRegexpOptions: {"strict":true},
    name: "getting-started___de"
  }, {
    path: "/de/lessons/",
    component: _2534f4fc,
    pathToRegexpOptions: {"strict":true},
    name: "lessons___de"
  }, {
    path: "/de/login/",
    component: _9a110364,
    pathToRegexpOptions: {"strict":true},
    name: "login___de"
  }, {
    path: "/de/notifications/",
    component: _7c26229a,
    pathToRegexpOptions: {"strict":true},
    name: "notifications___de"
  }, {
    path: "/de/plans/",
    component: _a0fd4ea6,
    pathToRegexpOptions: {"strict":true},
    name: "plans___de"
  }, {
    path: "/de/projects/",
    component: _5b6d18a3,
    pathToRegexpOptions: {"strict":true},
    name: "projects___de"
  }, {
    path: "/de/quote/",
    component: _6caadd72,
    pathToRegexpOptions: {"strict":true},
    name: "quote___de"
  }, {
    path: "/de/schools-districts/",
    component: _359a9aa2,
    pathToRegexpOptions: {"strict":true},
    name: "schools-districts___de"
  }, {
    path: "/de/settings/",
    component: _65eed628,
    pathToRegexpOptions: {"strict":true},
    name: "settings___de"
  }, {
    path: "/de/signup/",
    component: _df505bf6,
    pathToRegexpOptions: {"strict":true},
    name: "signup___de"
  }, {
    path: "/de/studio/",
    component: _231c5687,
    pathToRegexpOptions: {"strict":true},
    name: "studio___de"
  }, {
    path: "/de/what-is-visual-coding/",
    component: _056e7b68,
    pathToRegexpOptions: {"strict":true},
    name: "what-is-visual-coding___de"
  }, {
    path: "/de/why-creative-coding/",
    component: _6bd7494e,
    pathToRegexpOptions: {"strict":true},
    name: "why-creative-coding___de"
  }, {
    path: "/educators/ambassadors/",
    component: _98ac3512,
    pathToRegexpOptions: {"strict":true},
    name: "educators-ambassadors"
  }, {
    path: "/educators/faq/",
    component: _03adb5cb,
    pathToRegexpOptions: {"strict":true},
    name: "educators-faq"
  }, {
    path: "/educators/resources/",
    component: _fa6580cc,
    pathToRegexpOptions: {"strict":true},
    name: "educators-resources"
  }, {
    path: "/el/about/",
    component: _5b94f450,
    pathToRegexpOptions: {"strict":true},
    name: "about___el"
  }, {
    path: "/el/contact/",
    component: _1d68442b,
    pathToRegexpOptions: {"strict":true},
    name: "contact___el"
  }, {
    path: "/el/educators/",
    component: _ff0c7b72,
    pathToRegexpOptions: {"strict":true},
    name: "educators___el"
  }, {
    path: "/el/error/",
    component: _35b37ed3,
    pathToRegexpOptions: {"strict":true},
    name: "error___el"
  }, {
    path: "/el/features/",
    component: _e1993d7c,
    pathToRegexpOptions: {"strict":true},
    name: "features___el"
  }, {
    path: "/el/getting-started/",
    component: _02408ffa,
    pathToRegexpOptions: {"strict":true},
    name: "getting-started___el"
  }, {
    path: "/el/lessons/",
    component: _2534f4fc,
    pathToRegexpOptions: {"strict":true},
    name: "lessons___el"
  }, {
    path: "/el/login/",
    component: _9a110364,
    pathToRegexpOptions: {"strict":true},
    name: "login___el"
  }, {
    path: "/el/notifications/",
    component: _7c26229a,
    pathToRegexpOptions: {"strict":true},
    name: "notifications___el"
  }, {
    path: "/el/plans/",
    component: _a0fd4ea6,
    pathToRegexpOptions: {"strict":true},
    name: "plans___el"
  }, {
    path: "/el/projects/",
    component: _5b6d18a3,
    pathToRegexpOptions: {"strict":true},
    name: "projects___el"
  }, {
    path: "/el/quote/",
    component: _6caadd72,
    pathToRegexpOptions: {"strict":true},
    name: "quote___el"
  }, {
    path: "/el/schools-districts/",
    component: _359a9aa2,
    pathToRegexpOptions: {"strict":true},
    name: "schools-districts___el"
  }, {
    path: "/el/settings/",
    component: _65eed628,
    pathToRegexpOptions: {"strict":true},
    name: "settings___el"
  }, {
    path: "/el/signup/",
    component: _df505bf6,
    pathToRegexpOptions: {"strict":true},
    name: "signup___el"
  }, {
    path: "/el/studio/",
    component: _231c5687,
    pathToRegexpOptions: {"strict":true},
    name: "studio___el"
  }, {
    path: "/el/what-is-visual-coding/",
    component: _056e7b68,
    pathToRegexpOptions: {"strict":true},
    name: "what-is-visual-coding___el"
  }, {
    path: "/el/why-creative-coding/",
    component: _6bd7494e,
    pathToRegexpOptions: {"strict":true},
    name: "why-creative-coding___el"
  }, {
    path: "/es/about/",
    component: _5b94f450,
    pathToRegexpOptions: {"strict":true},
    name: "about___es"
  }, {
    path: "/es/contact/",
    component: _1d68442b,
    pathToRegexpOptions: {"strict":true},
    name: "contact___es"
  }, {
    path: "/es/educators/",
    component: _ff0c7b72,
    pathToRegexpOptions: {"strict":true},
    name: "educators___es"
  }, {
    path: "/es/error/",
    component: _35b37ed3,
    pathToRegexpOptions: {"strict":true},
    name: "error___es"
  }, {
    path: "/es/features/",
    component: _e1993d7c,
    pathToRegexpOptions: {"strict":true},
    name: "features___es"
  }, {
    path: "/es/getting-started/",
    component: _02408ffa,
    pathToRegexpOptions: {"strict":true},
    name: "getting-started___es"
  }, {
    path: "/es/lessons/",
    component: _2534f4fc,
    pathToRegexpOptions: {"strict":true},
    name: "lessons___es"
  }, {
    path: "/es/login/",
    component: _9a110364,
    pathToRegexpOptions: {"strict":true},
    name: "login___es"
  }, {
    path: "/es/notifications/",
    component: _7c26229a,
    pathToRegexpOptions: {"strict":true},
    name: "notifications___es"
  }, {
    path: "/es/plans/",
    component: _a0fd4ea6,
    pathToRegexpOptions: {"strict":true},
    name: "plans___es"
  }, {
    path: "/es/projects/",
    component: _5b6d18a3,
    pathToRegexpOptions: {"strict":true},
    name: "projects___es"
  }, {
    path: "/es/quote/",
    component: _6caadd72,
    pathToRegexpOptions: {"strict":true},
    name: "quote___es"
  }, {
    path: "/es/schools-districts/",
    component: _359a9aa2,
    pathToRegexpOptions: {"strict":true},
    name: "schools-districts___es"
  }, {
    path: "/es/settings/",
    component: _65eed628,
    pathToRegexpOptions: {"strict":true},
    name: "settings___es"
  }, {
    path: "/es/signup/",
    component: _df505bf6,
    pathToRegexpOptions: {"strict":true},
    name: "signup___es"
  }, {
    path: "/es/studio/",
    component: _231c5687,
    pathToRegexpOptions: {"strict":true},
    name: "studio___es"
  }, {
    path: "/es/what-is-visual-coding/",
    component: _056e7b68,
    pathToRegexpOptions: {"strict":true},
    name: "what-is-visual-coding___es"
  }, {
    path: "/es/why-creative-coding/",
    component: _6bd7494e,
    pathToRegexpOptions: {"strict":true},
    name: "why-creative-coding___es"
  }, {
    path: "/fr/about/",
    component: _5b94f450,
    pathToRegexpOptions: {"strict":true},
    name: "about___fr"
  }, {
    path: "/fr/contact/",
    component: _1d68442b,
    pathToRegexpOptions: {"strict":true},
    name: "contact___fr"
  }, {
    path: "/fr/educators/",
    component: _ff0c7b72,
    pathToRegexpOptions: {"strict":true},
    name: "educators___fr"
  }, {
    path: "/fr/error/",
    component: _35b37ed3,
    pathToRegexpOptions: {"strict":true},
    name: "error___fr"
  }, {
    path: "/fr/features/",
    component: _e1993d7c,
    pathToRegexpOptions: {"strict":true},
    name: "features___fr"
  }, {
    path: "/fr/getting-started/",
    component: _02408ffa,
    pathToRegexpOptions: {"strict":true},
    name: "getting-started___fr"
  }, {
    path: "/fr/lessons/",
    component: _2534f4fc,
    pathToRegexpOptions: {"strict":true},
    name: "lessons___fr"
  }, {
    path: "/fr/login/",
    component: _9a110364,
    pathToRegexpOptions: {"strict":true},
    name: "login___fr"
  }, {
    path: "/fr/notifications/",
    component: _7c26229a,
    pathToRegexpOptions: {"strict":true},
    name: "notifications___fr"
  }, {
    path: "/fr/plans/",
    component: _a0fd4ea6,
    pathToRegexpOptions: {"strict":true},
    name: "plans___fr"
  }, {
    path: "/fr/projects/",
    component: _5b6d18a3,
    pathToRegexpOptions: {"strict":true},
    name: "projects___fr"
  }, {
    path: "/fr/quote/",
    component: _6caadd72,
    pathToRegexpOptions: {"strict":true},
    name: "quote___fr"
  }, {
    path: "/fr/schools-districts/",
    component: _359a9aa2,
    pathToRegexpOptions: {"strict":true},
    name: "schools-districts___fr"
  }, {
    path: "/fr/settings/",
    component: _65eed628,
    pathToRegexpOptions: {"strict":true},
    name: "settings___fr"
  }, {
    path: "/fr/signup/",
    component: _df505bf6,
    pathToRegexpOptions: {"strict":true},
    name: "signup___fr"
  }, {
    path: "/fr/studio/",
    component: _231c5687,
    pathToRegexpOptions: {"strict":true},
    name: "studio___fr"
  }, {
    path: "/fr/what-is-visual-coding/",
    component: _056e7b68,
    pathToRegexpOptions: {"strict":true},
    name: "what-is-visual-coding___fr"
  }, {
    path: "/fr/why-creative-coding/",
    component: _6bd7494e,
    pathToRegexpOptions: {"strict":true},
    name: "why-creative-coding___fr"
  }, {
    path: "/it/about/",
    component: _5b94f450,
    pathToRegexpOptions: {"strict":true},
    name: "about___it"
  }, {
    path: "/it/contact/",
    component: _1d68442b,
    pathToRegexpOptions: {"strict":true},
    name: "contact___it"
  }, {
    path: "/it/educators/",
    component: _ff0c7b72,
    pathToRegexpOptions: {"strict":true},
    name: "educators___it"
  }, {
    path: "/it/error/",
    component: _35b37ed3,
    pathToRegexpOptions: {"strict":true},
    name: "error___it"
  }, {
    path: "/it/features/",
    component: _e1993d7c,
    pathToRegexpOptions: {"strict":true},
    name: "features___it"
  }, {
    path: "/it/getting-started/",
    component: _02408ffa,
    pathToRegexpOptions: {"strict":true},
    name: "getting-started___it"
  }, {
    path: "/it/lessons/",
    component: _2534f4fc,
    pathToRegexpOptions: {"strict":true},
    name: "lessons___it"
  }, {
    path: "/it/login/",
    component: _9a110364,
    pathToRegexpOptions: {"strict":true},
    name: "login___it"
  }, {
    path: "/it/notifications/",
    component: _7c26229a,
    pathToRegexpOptions: {"strict":true},
    name: "notifications___it"
  }, {
    path: "/it/plans/",
    component: _a0fd4ea6,
    pathToRegexpOptions: {"strict":true},
    name: "plans___it"
  }, {
    path: "/it/projects/",
    component: _5b6d18a3,
    pathToRegexpOptions: {"strict":true},
    name: "projects___it"
  }, {
    path: "/it/quote/",
    component: _6caadd72,
    pathToRegexpOptions: {"strict":true},
    name: "quote___it"
  }, {
    path: "/it/schools-districts/",
    component: _359a9aa2,
    pathToRegexpOptions: {"strict":true},
    name: "schools-districts___it"
  }, {
    path: "/it/settings/",
    component: _65eed628,
    pathToRegexpOptions: {"strict":true},
    name: "settings___it"
  }, {
    path: "/it/signup/",
    component: _df505bf6,
    pathToRegexpOptions: {"strict":true},
    name: "signup___it"
  }, {
    path: "/it/studio/",
    component: _231c5687,
    pathToRegexpOptions: {"strict":true},
    name: "studio___it"
  }, {
    path: "/it/what-is-visual-coding/",
    component: _056e7b68,
    pathToRegexpOptions: {"strict":true},
    name: "what-is-visual-coding___it"
  }, {
    path: "/it/why-creative-coding/",
    component: _6bd7494e,
    pathToRegexpOptions: {"strict":true},
    name: "why-creative-coding___it"
  }, {
    path: "/lessons/edit/",
    component: _e23b289c,
    pathToRegexpOptions: {"strict":true},
    name: "lessons-edit___en"
  }, {
    path: "/login/qr/",
    component: _625296d5,
    pathToRegexpOptions: {"strict":true},
    name: "login-qr___en"
  }, {
    path: "/plans/educator_monthly/",
    component: _6964bbf4,
    pathToRegexpOptions: {"strict":true},
    name: "plans-educator_monthly___en"
  }, {
    path: "/plans/educator_plus_monthly/",
    component: _1211c082,
    pathToRegexpOptions: {"strict":true},
    name: "plans-educator_plus_monthly___en"
  }, {
    path: "/plans/educator_plus_yearly/",
    component: _d7655d70,
    pathToRegexpOptions: {"strict":true},
    name: "plans-educator_plus_yearly___en"
  }, {
    path: "/plans/educator_yearly/",
    component: _2789ea21,
    pathToRegexpOptions: {"strict":true},
    name: "plans-educator_yearly___en"
  }, {
    path: "/policy/privacy/",
    component: _1f6acd21,
    pathToRegexpOptions: {"strict":true},
    name: "policy-privacy___en"
  }, {
    path: "/policy/terms/",
    component: _69bfa7e0,
    pathToRegexpOptions: {"strict":true},
    name: "policy-terms___en"
  }, {
    path: "/policy/third-parties/",
    component: _2acaf512,
    pathToRegexpOptions: {"strict":true},
    name: "policy-third-parties___en"
  }, {
    path: "/pt_PT/about/",
    component: _5b94f450,
    pathToRegexpOptions: {"strict":true},
    name: "about___pt_PT"
  }, {
    path: "/pt_PT/contact/",
    component: _1d68442b,
    pathToRegexpOptions: {"strict":true},
    name: "contact___pt_PT"
  }, {
    path: "/pt_PT/educators/",
    component: _ff0c7b72,
    pathToRegexpOptions: {"strict":true},
    name: "educators___pt_PT"
  }, {
    path: "/pt_PT/error/",
    component: _35b37ed3,
    pathToRegexpOptions: {"strict":true},
    name: "error___pt_PT"
  }, {
    path: "/pt_PT/features/",
    component: _e1993d7c,
    pathToRegexpOptions: {"strict":true},
    name: "features___pt_PT"
  }, {
    path: "/pt_PT/getting-started/",
    component: _02408ffa,
    pathToRegexpOptions: {"strict":true},
    name: "getting-started___pt_PT"
  }, {
    path: "/pt_PT/lessons/",
    component: _2534f4fc,
    pathToRegexpOptions: {"strict":true},
    name: "lessons___pt_PT"
  }, {
    path: "/pt_PT/login/",
    component: _9a110364,
    pathToRegexpOptions: {"strict":true},
    name: "login___pt_PT"
  }, {
    path: "/pt_PT/notifications/",
    component: _7c26229a,
    pathToRegexpOptions: {"strict":true},
    name: "notifications___pt_PT"
  }, {
    path: "/pt_PT/plans/",
    component: _a0fd4ea6,
    pathToRegexpOptions: {"strict":true},
    name: "plans___pt_PT"
  }, {
    path: "/pt_PT/projects/",
    component: _5b6d18a3,
    pathToRegexpOptions: {"strict":true},
    name: "projects___pt_PT"
  }, {
    path: "/pt_PT/quote/",
    component: _6caadd72,
    pathToRegexpOptions: {"strict":true},
    name: "quote___pt_PT"
  }, {
    path: "/pt_PT/schools-districts/",
    component: _359a9aa2,
    pathToRegexpOptions: {"strict":true},
    name: "schools-districts___pt_PT"
  }, {
    path: "/pt_PT/settings/",
    component: _65eed628,
    pathToRegexpOptions: {"strict":true},
    name: "settings___pt_PT"
  }, {
    path: "/pt_PT/signup/",
    component: _df505bf6,
    pathToRegexpOptions: {"strict":true},
    name: "signup___pt_PT"
  }, {
    path: "/pt_PT/studio/",
    component: _231c5687,
    pathToRegexpOptions: {"strict":true},
    name: "studio___pt_PT"
  }, {
    path: "/pt_PT/what-is-visual-coding/",
    component: _056e7b68,
    pathToRegexpOptions: {"strict":true},
    name: "what-is-visual-coding___pt_PT"
  }, {
    path: "/pt_PT/why-creative-coding/",
    component: _6bd7494e,
    pathToRegexpOptions: {"strict":true},
    name: "why-creative-coding___pt_PT"
  }, {
    path: "/signup/classlink/",
    component: _c97e1db6,
    pathToRegexpOptions: {"strict":true},
    name: "signup-classlink___en"
  }, {
    path: "/signup/clever/",
    component: _66bd7be4,
    pathToRegexpOptions: {"strict":true},
    name: "signup-clever___en"
  }, {
    path: "/signup/teachers/",
    component: _4750f96e,
    pathToRegexpOptions: {"strict":true},
    name: "signup-teachers___en"
  }, {
    path: "/de/account/confirm-email/",
    component: _69b500c7,
    pathToRegexpOptions: {"strict":true},
    name: "account-confirm-email___de"
  }, {
    path: "/de/account/password-change/",
    component: _50d16328,
    pathToRegexpOptions: {"strict":true},
    name: "account-password-change___de"
  }, {
    path: "/de/account/reset-password/",
    component: _07061c11,
    pathToRegexpOptions: {"strict":true},
    name: "account-reset-password___de"
  }, {
    path: "/de/classes/select/",
    component: _433ea935,
    pathToRegexpOptions: {"strict":true},
    name: "classes-select___de"
  }, {
    path: "/de/lessons/edit/",
    component: _e23b289c,
    pathToRegexpOptions: {"strict":true},
    name: "lessons-edit___de"
  }, {
    path: "/de/login/qr/",
    component: _625296d5,
    pathToRegexpOptions: {"strict":true},
    name: "login-qr___de"
  }, {
    path: "/de/plans/educator_monthly/",
    component: _6964bbf4,
    pathToRegexpOptions: {"strict":true},
    name: "plans-educator_monthly___de"
  }, {
    path: "/de/plans/educator_plus_monthly/",
    component: _1211c082,
    pathToRegexpOptions: {"strict":true},
    name: "plans-educator_plus_monthly___de"
  }, {
    path: "/de/plans/educator_plus_yearly/",
    component: _d7655d70,
    pathToRegexpOptions: {"strict":true},
    name: "plans-educator_plus_yearly___de"
  }, {
    path: "/de/plans/educator_yearly/",
    component: _2789ea21,
    pathToRegexpOptions: {"strict":true},
    name: "plans-educator_yearly___de"
  }, {
    path: "/de/policy/privacy/",
    component: _1f6acd21,
    pathToRegexpOptions: {"strict":true},
    name: "policy-privacy___de"
  }, {
    path: "/de/policy/terms/",
    component: _69bfa7e0,
    pathToRegexpOptions: {"strict":true},
    name: "policy-terms___de"
  }, {
    path: "/de/policy/third-parties/",
    component: _2acaf512,
    pathToRegexpOptions: {"strict":true},
    name: "policy-third-parties___de"
  }, {
    path: "/de/signup/classlink/",
    component: _c97e1db6,
    pathToRegexpOptions: {"strict":true},
    name: "signup-classlink___de"
  }, {
    path: "/de/signup/clever/",
    component: _66bd7be4,
    pathToRegexpOptions: {"strict":true},
    name: "signup-clever___de"
  }, {
    path: "/de/signup/teachers/",
    component: _4750f96e,
    pathToRegexpOptions: {"strict":true},
    name: "signup-teachers___de"
  }, {
    path: "/el/account/confirm-email/",
    component: _69b500c7,
    pathToRegexpOptions: {"strict":true},
    name: "account-confirm-email___el"
  }, {
    path: "/el/account/password-change/",
    component: _50d16328,
    pathToRegexpOptions: {"strict":true},
    name: "account-password-change___el"
  }, {
    path: "/el/account/reset-password/",
    component: _07061c11,
    pathToRegexpOptions: {"strict":true},
    name: "account-reset-password___el"
  }, {
    path: "/el/classes/select/",
    component: _433ea935,
    pathToRegexpOptions: {"strict":true},
    name: "classes-select___el"
  }, {
    path: "/el/lessons/edit/",
    component: _e23b289c,
    pathToRegexpOptions: {"strict":true},
    name: "lessons-edit___el"
  }, {
    path: "/el/login/qr/",
    component: _625296d5,
    pathToRegexpOptions: {"strict":true},
    name: "login-qr___el"
  }, {
    path: "/el/plans/educator_monthly/",
    component: _6964bbf4,
    pathToRegexpOptions: {"strict":true},
    name: "plans-educator_monthly___el"
  }, {
    path: "/el/plans/educator_plus_monthly/",
    component: _1211c082,
    pathToRegexpOptions: {"strict":true},
    name: "plans-educator_plus_monthly___el"
  }, {
    path: "/el/plans/educator_plus_yearly/",
    component: _d7655d70,
    pathToRegexpOptions: {"strict":true},
    name: "plans-educator_plus_yearly___el"
  }, {
    path: "/el/plans/educator_yearly/",
    component: _2789ea21,
    pathToRegexpOptions: {"strict":true},
    name: "plans-educator_yearly___el"
  }, {
    path: "/el/policy/privacy/",
    component: _1f6acd21,
    pathToRegexpOptions: {"strict":true},
    name: "policy-privacy___el"
  }, {
    path: "/el/policy/terms/",
    component: _69bfa7e0,
    pathToRegexpOptions: {"strict":true},
    name: "policy-terms___el"
  }, {
    path: "/el/policy/third-parties/",
    component: _2acaf512,
    pathToRegexpOptions: {"strict":true},
    name: "policy-third-parties___el"
  }, {
    path: "/el/signup/classlink/",
    component: _c97e1db6,
    pathToRegexpOptions: {"strict":true},
    name: "signup-classlink___el"
  }, {
    path: "/el/signup/clever/",
    component: _66bd7be4,
    pathToRegexpOptions: {"strict":true},
    name: "signup-clever___el"
  }, {
    path: "/el/signup/teachers/",
    component: _4750f96e,
    pathToRegexpOptions: {"strict":true},
    name: "signup-teachers___el"
  }, {
    path: "/es/account/confirm-email/",
    component: _69b500c7,
    pathToRegexpOptions: {"strict":true},
    name: "account-confirm-email___es"
  }, {
    path: "/es/account/password-change/",
    component: _50d16328,
    pathToRegexpOptions: {"strict":true},
    name: "account-password-change___es"
  }, {
    path: "/es/account/reset-password/",
    component: _07061c11,
    pathToRegexpOptions: {"strict":true},
    name: "account-reset-password___es"
  }, {
    path: "/es/classes/select/",
    component: _433ea935,
    pathToRegexpOptions: {"strict":true},
    name: "classes-select___es"
  }, {
    path: "/es/lessons/edit/",
    component: _e23b289c,
    pathToRegexpOptions: {"strict":true},
    name: "lessons-edit___es"
  }, {
    path: "/es/login/qr/",
    component: _625296d5,
    pathToRegexpOptions: {"strict":true},
    name: "login-qr___es"
  }, {
    path: "/es/plans/educator_monthly/",
    component: _6964bbf4,
    pathToRegexpOptions: {"strict":true},
    name: "plans-educator_monthly___es"
  }, {
    path: "/es/plans/educator_plus_monthly/",
    component: _1211c082,
    pathToRegexpOptions: {"strict":true},
    name: "plans-educator_plus_monthly___es"
  }, {
    path: "/es/plans/educator_plus_yearly/",
    component: _d7655d70,
    pathToRegexpOptions: {"strict":true},
    name: "plans-educator_plus_yearly___es"
  }, {
    path: "/es/plans/educator_yearly/",
    component: _2789ea21,
    pathToRegexpOptions: {"strict":true},
    name: "plans-educator_yearly___es"
  }, {
    path: "/es/policy/privacy/",
    component: _1f6acd21,
    pathToRegexpOptions: {"strict":true},
    name: "policy-privacy___es"
  }, {
    path: "/es/policy/terms/",
    component: _69bfa7e0,
    pathToRegexpOptions: {"strict":true},
    name: "policy-terms___es"
  }, {
    path: "/es/policy/third-parties/",
    component: _2acaf512,
    pathToRegexpOptions: {"strict":true},
    name: "policy-third-parties___es"
  }, {
    path: "/es/signup/classlink/",
    component: _c97e1db6,
    pathToRegexpOptions: {"strict":true},
    name: "signup-classlink___es"
  }, {
    path: "/es/signup/clever/",
    component: _66bd7be4,
    pathToRegexpOptions: {"strict":true},
    name: "signup-clever___es"
  }, {
    path: "/es/signup/teachers/",
    component: _4750f96e,
    pathToRegexpOptions: {"strict":true},
    name: "signup-teachers___es"
  }, {
    path: "/fr/account/confirm-email/",
    component: _69b500c7,
    pathToRegexpOptions: {"strict":true},
    name: "account-confirm-email___fr"
  }, {
    path: "/fr/account/password-change/",
    component: _50d16328,
    pathToRegexpOptions: {"strict":true},
    name: "account-password-change___fr"
  }, {
    path: "/fr/account/reset-password/",
    component: _07061c11,
    pathToRegexpOptions: {"strict":true},
    name: "account-reset-password___fr"
  }, {
    path: "/fr/classes/select/",
    component: _433ea935,
    pathToRegexpOptions: {"strict":true},
    name: "classes-select___fr"
  }, {
    path: "/fr/lessons/edit/",
    component: _e23b289c,
    pathToRegexpOptions: {"strict":true},
    name: "lessons-edit___fr"
  }, {
    path: "/fr/login/qr/",
    component: _625296d5,
    pathToRegexpOptions: {"strict":true},
    name: "login-qr___fr"
  }, {
    path: "/fr/plans/educator_monthly/",
    component: _6964bbf4,
    pathToRegexpOptions: {"strict":true},
    name: "plans-educator_monthly___fr"
  }, {
    path: "/fr/plans/educator_plus_monthly/",
    component: _1211c082,
    pathToRegexpOptions: {"strict":true},
    name: "plans-educator_plus_monthly___fr"
  }, {
    path: "/fr/plans/educator_plus_yearly/",
    component: _d7655d70,
    pathToRegexpOptions: {"strict":true},
    name: "plans-educator_plus_yearly___fr"
  }, {
    path: "/fr/plans/educator_yearly/",
    component: _2789ea21,
    pathToRegexpOptions: {"strict":true},
    name: "plans-educator_yearly___fr"
  }, {
    path: "/fr/policy/privacy/",
    component: _1f6acd21,
    pathToRegexpOptions: {"strict":true},
    name: "policy-privacy___fr"
  }, {
    path: "/fr/policy/terms/",
    component: _69bfa7e0,
    pathToRegexpOptions: {"strict":true},
    name: "policy-terms___fr"
  }, {
    path: "/fr/policy/third-parties/",
    component: _2acaf512,
    pathToRegexpOptions: {"strict":true},
    name: "policy-third-parties___fr"
  }, {
    path: "/fr/signup/classlink/",
    component: _c97e1db6,
    pathToRegexpOptions: {"strict":true},
    name: "signup-classlink___fr"
  }, {
    path: "/fr/signup/clever/",
    component: _66bd7be4,
    pathToRegexpOptions: {"strict":true},
    name: "signup-clever___fr"
  }, {
    path: "/fr/signup/teachers/",
    component: _4750f96e,
    pathToRegexpOptions: {"strict":true},
    name: "signup-teachers___fr"
  }, {
    path: "/it/account/confirm-email/",
    component: _69b500c7,
    pathToRegexpOptions: {"strict":true},
    name: "account-confirm-email___it"
  }, {
    path: "/it/account/password-change/",
    component: _50d16328,
    pathToRegexpOptions: {"strict":true},
    name: "account-password-change___it"
  }, {
    path: "/it/account/reset-password/",
    component: _07061c11,
    pathToRegexpOptions: {"strict":true},
    name: "account-reset-password___it"
  }, {
    path: "/it/classes/select/",
    component: _433ea935,
    pathToRegexpOptions: {"strict":true},
    name: "classes-select___it"
  }, {
    path: "/it/lessons/edit/",
    component: _e23b289c,
    pathToRegexpOptions: {"strict":true},
    name: "lessons-edit___it"
  }, {
    path: "/it/login/qr/",
    component: _625296d5,
    pathToRegexpOptions: {"strict":true},
    name: "login-qr___it"
  }, {
    path: "/it/plans/educator_monthly/",
    component: _6964bbf4,
    pathToRegexpOptions: {"strict":true},
    name: "plans-educator_monthly___it"
  }, {
    path: "/it/plans/educator_plus_monthly/",
    component: _1211c082,
    pathToRegexpOptions: {"strict":true},
    name: "plans-educator_plus_monthly___it"
  }, {
    path: "/it/plans/educator_plus_yearly/",
    component: _d7655d70,
    pathToRegexpOptions: {"strict":true},
    name: "plans-educator_plus_yearly___it"
  }, {
    path: "/it/plans/educator_yearly/",
    component: _2789ea21,
    pathToRegexpOptions: {"strict":true},
    name: "plans-educator_yearly___it"
  }, {
    path: "/it/policy/privacy/",
    component: _1f6acd21,
    pathToRegexpOptions: {"strict":true},
    name: "policy-privacy___it"
  }, {
    path: "/it/policy/terms/",
    component: _69bfa7e0,
    pathToRegexpOptions: {"strict":true},
    name: "policy-terms___it"
  }, {
    path: "/it/policy/third-parties/",
    component: _2acaf512,
    pathToRegexpOptions: {"strict":true},
    name: "policy-third-parties___it"
  }, {
    path: "/it/signup/classlink/",
    component: _c97e1db6,
    pathToRegexpOptions: {"strict":true},
    name: "signup-classlink___it"
  }, {
    path: "/it/signup/clever/",
    component: _66bd7be4,
    pathToRegexpOptions: {"strict":true},
    name: "signup-clever___it"
  }, {
    path: "/it/signup/teachers/",
    component: _4750f96e,
    pathToRegexpOptions: {"strict":true},
    name: "signup-teachers___it"
  }, {
    path: "/pt_PT/account/confirm-email/",
    component: _69b500c7,
    pathToRegexpOptions: {"strict":true},
    name: "account-confirm-email___pt_PT"
  }, {
    path: "/pt_PT/account/password-change/",
    component: _50d16328,
    pathToRegexpOptions: {"strict":true},
    name: "account-password-change___pt_PT"
  }, {
    path: "/pt_PT/account/reset-password/",
    component: _07061c11,
    pathToRegexpOptions: {"strict":true},
    name: "account-reset-password___pt_PT"
  }, {
    path: "/pt_PT/classes/select/",
    component: _433ea935,
    pathToRegexpOptions: {"strict":true},
    name: "classes-select___pt_PT"
  }, {
    path: "/pt_PT/lessons/edit/",
    component: _e23b289c,
    pathToRegexpOptions: {"strict":true},
    name: "lessons-edit___pt_PT"
  }, {
    path: "/pt_PT/login/qr/",
    component: _625296d5,
    pathToRegexpOptions: {"strict":true},
    name: "login-qr___pt_PT"
  }, {
    path: "/pt_PT/plans/educator_monthly/",
    component: _6964bbf4,
    pathToRegexpOptions: {"strict":true},
    name: "plans-educator_monthly___pt_PT"
  }, {
    path: "/pt_PT/plans/educator_plus_monthly/",
    component: _1211c082,
    pathToRegexpOptions: {"strict":true},
    name: "plans-educator_plus_monthly___pt_PT"
  }, {
    path: "/pt_PT/plans/educator_plus_yearly/",
    component: _d7655d70,
    pathToRegexpOptions: {"strict":true},
    name: "plans-educator_plus_yearly___pt_PT"
  }, {
    path: "/pt_PT/plans/educator_yearly/",
    component: _2789ea21,
    pathToRegexpOptions: {"strict":true},
    name: "plans-educator_yearly___pt_PT"
  }, {
    path: "/pt_PT/policy/privacy/",
    component: _1f6acd21,
    pathToRegexpOptions: {"strict":true},
    name: "policy-privacy___pt_PT"
  }, {
    path: "/pt_PT/policy/terms/",
    component: _69bfa7e0,
    pathToRegexpOptions: {"strict":true},
    name: "policy-terms___pt_PT"
  }, {
    path: "/pt_PT/policy/third-parties/",
    component: _2acaf512,
    pathToRegexpOptions: {"strict":true},
    name: "policy-third-parties___pt_PT"
  }, {
    path: "/pt_PT/signup/classlink/",
    component: _c97e1db6,
    pathToRegexpOptions: {"strict":true},
    name: "signup-classlink___pt_PT"
  }, {
    path: "/pt_PT/signup/clever/",
    component: _66bd7be4,
    pathToRegexpOptions: {"strict":true},
    name: "signup-clever___pt_PT"
  }, {
    path: "/pt_PT/signup/teachers/",
    component: _4750f96e,
    pathToRegexpOptions: {"strict":true},
    name: "signup-teachers___pt_PT"
  }, {
    path: "/de/account/password-change/:token?/",
    component: _4f229994,
    pathToRegexpOptions: {"strict":true},
    name: "account-password-change-token___de"
  }, {
    path: "/de/classes/select/:slug/",
    component: _418807ed,
    pathToRegexpOptions: {"strict":true},
    name: "classes-select-slug___de"
  }, {
    path: "/de/lessons/edit/:slug/",
    component: _e5a86b2c,
    pathToRegexpOptions: {"strict":true},
    name: "lessons-edit-slug___de"
  }, {
    path: "/de/lessons/page/:page?/",
    component: _43edb2ae,
    pathToRegexpOptions: {"strict":true},
    name: "lessons-page-page___de"
  }, {
    path: "/de/lessons/select/:slug?/",
    component: _7780c890,
    pathToRegexpOptions: {"strict":true},
    name: "lessons-select-slug___de"
  }, {
    path: "/de/projects/page/:page?/",
    component: _f2e89de0,
    pathToRegexpOptions: {"strict":true},
    name: "projects-page-page___de"
  }, {
    path: "/de/studio/edit/:slug?/",
    component: _374897b5,
    pathToRegexpOptions: {"strict":true},
    name: "studio-edit-slug___de"
  }, {
    path: "/el/account/password-change/:token?/",
    component: _4f229994,
    pathToRegexpOptions: {"strict":true},
    name: "account-password-change-token___el"
  }, {
    path: "/el/classes/select/:slug/",
    component: _418807ed,
    pathToRegexpOptions: {"strict":true},
    name: "classes-select-slug___el"
  }, {
    path: "/el/lessons/edit/:slug/",
    component: _e5a86b2c,
    pathToRegexpOptions: {"strict":true},
    name: "lessons-edit-slug___el"
  }, {
    path: "/el/lessons/page/:page?/",
    component: _43edb2ae,
    pathToRegexpOptions: {"strict":true},
    name: "lessons-page-page___el"
  }, {
    path: "/el/lessons/select/:slug?/",
    component: _7780c890,
    pathToRegexpOptions: {"strict":true},
    name: "lessons-select-slug___el"
  }, {
    path: "/el/projects/page/:page?/",
    component: _f2e89de0,
    pathToRegexpOptions: {"strict":true},
    name: "projects-page-page___el"
  }, {
    path: "/el/studio/edit/:slug?/",
    component: _374897b5,
    pathToRegexpOptions: {"strict":true},
    name: "studio-edit-slug___el"
  }, {
    path: "/es/account/password-change/:token?/",
    component: _4f229994,
    pathToRegexpOptions: {"strict":true},
    name: "account-password-change-token___es"
  }, {
    path: "/es/classes/select/:slug/",
    component: _418807ed,
    pathToRegexpOptions: {"strict":true},
    name: "classes-select-slug___es"
  }, {
    path: "/es/lessons/edit/:slug/",
    component: _e5a86b2c,
    pathToRegexpOptions: {"strict":true},
    name: "lessons-edit-slug___es"
  }, {
    path: "/es/lessons/page/:page?/",
    component: _43edb2ae,
    pathToRegexpOptions: {"strict":true},
    name: "lessons-page-page___es"
  }, {
    path: "/es/lessons/select/:slug?/",
    component: _7780c890,
    pathToRegexpOptions: {"strict":true},
    name: "lessons-select-slug___es"
  }, {
    path: "/es/projects/page/:page?/",
    component: _f2e89de0,
    pathToRegexpOptions: {"strict":true},
    name: "projects-page-page___es"
  }, {
    path: "/es/studio/edit/:slug?/",
    component: _374897b5,
    pathToRegexpOptions: {"strict":true},
    name: "studio-edit-slug___es"
  }, {
    path: "/fr/account/password-change/:token?/",
    component: _4f229994,
    pathToRegexpOptions: {"strict":true},
    name: "account-password-change-token___fr"
  }, {
    path: "/fr/classes/select/:slug/",
    component: _418807ed,
    pathToRegexpOptions: {"strict":true},
    name: "classes-select-slug___fr"
  }, {
    path: "/fr/lessons/edit/:slug/",
    component: _e5a86b2c,
    pathToRegexpOptions: {"strict":true},
    name: "lessons-edit-slug___fr"
  }, {
    path: "/fr/lessons/page/:page?/",
    component: _43edb2ae,
    pathToRegexpOptions: {"strict":true},
    name: "lessons-page-page___fr"
  }, {
    path: "/fr/lessons/select/:slug?/",
    component: _7780c890,
    pathToRegexpOptions: {"strict":true},
    name: "lessons-select-slug___fr"
  }, {
    path: "/fr/projects/page/:page?/",
    component: _f2e89de0,
    pathToRegexpOptions: {"strict":true},
    name: "projects-page-page___fr"
  }, {
    path: "/fr/studio/edit/:slug?/",
    component: _374897b5,
    pathToRegexpOptions: {"strict":true},
    name: "studio-edit-slug___fr"
  }, {
    path: "/it/account/password-change/:token?/",
    component: _4f229994,
    pathToRegexpOptions: {"strict":true},
    name: "account-password-change-token___it"
  }, {
    path: "/it/classes/select/:slug/",
    component: _418807ed,
    pathToRegexpOptions: {"strict":true},
    name: "classes-select-slug___it"
  }, {
    path: "/it/lessons/edit/:slug/",
    component: _e5a86b2c,
    pathToRegexpOptions: {"strict":true},
    name: "lessons-edit-slug___it"
  }, {
    path: "/it/lessons/page/:page?/",
    component: _43edb2ae,
    pathToRegexpOptions: {"strict":true},
    name: "lessons-page-page___it"
  }, {
    path: "/it/lessons/select/:slug?/",
    component: _7780c890,
    pathToRegexpOptions: {"strict":true},
    name: "lessons-select-slug___it"
  }, {
    path: "/it/projects/page/:page?/",
    component: _f2e89de0,
    pathToRegexpOptions: {"strict":true},
    name: "projects-page-page___it"
  }, {
    path: "/it/studio/edit/:slug?/",
    component: _374897b5,
    pathToRegexpOptions: {"strict":true},
    name: "studio-edit-slug___it"
  }, {
    path: "/pt_PT/account/password-change/:token?/",
    component: _4f229994,
    pathToRegexpOptions: {"strict":true},
    name: "account-password-change-token___pt_PT"
  }, {
    path: "/pt_PT/classes/select/:slug/",
    component: _418807ed,
    pathToRegexpOptions: {"strict":true},
    name: "classes-select-slug___pt_PT"
  }, {
    path: "/pt_PT/lessons/edit/:slug/",
    component: _e5a86b2c,
    pathToRegexpOptions: {"strict":true},
    name: "lessons-edit-slug___pt_PT"
  }, {
    path: "/pt_PT/lessons/page/:page?/",
    component: _43edb2ae,
    pathToRegexpOptions: {"strict":true},
    name: "lessons-page-page___pt_PT"
  }, {
    path: "/pt_PT/lessons/select/:slug?/",
    component: _7780c890,
    pathToRegexpOptions: {"strict":true},
    name: "lessons-select-slug___pt_PT"
  }, {
    path: "/pt_PT/projects/page/:page?/",
    component: _f2e89de0,
    pathToRegexpOptions: {"strict":true},
    name: "projects-page-page___pt_PT"
  }, {
    path: "/pt_PT/studio/edit/:slug?/",
    component: _374897b5,
    pathToRegexpOptions: {"strict":true},
    name: "studio-edit-slug___pt_PT"
  }, {
    path: "/account/password-change/:token?/",
    component: _4f229994,
    pathToRegexpOptions: {"strict":true},
    name: "account-password-change-token___en"
  }, {
    path: "/classes/select/:slug/",
    component: _418807ed,
    pathToRegexpOptions: {"strict":true},
    name: "classes-select-slug___en"
  }, {
    path: "/de/classes/:classSlug/",
    component: _35dc2eed,
    pathToRegexpOptions: {"strict":true},
    name: "classes-classSlug___de"
  }, {
    path: "/de/invite/:code?/",
    component: _6aba546e,
    pathToRegexpOptions: {"strict":true},
    name: "invite-code___de"
  }, {
    path: "/de/lessons/:slug/",
    component: _237e53b4,
    pathToRegexpOptions: {"strict":true},
    name: "lessons-slug___de"
  }, {
    path: "/de/pay/:slug/",
    component: _39e5d60a,
    pathToRegexpOptions: {"strict":true},
    name: "pay-slug___de"
  }, {
    path: "/de/projects/:slug/",
    component: _08c2f0c7,
    pathToRegexpOptions: {"strict":true},
    name: "projects-slug___de"
  }, {
    path: "/el/classes/:classSlug/",
    component: _35dc2eed,
    pathToRegexpOptions: {"strict":true},
    name: "classes-classSlug___el"
  }, {
    path: "/el/invite/:code?/",
    component: _6aba546e,
    pathToRegexpOptions: {"strict":true},
    name: "invite-code___el"
  }, {
    path: "/el/lessons/:slug/",
    component: _237e53b4,
    pathToRegexpOptions: {"strict":true},
    name: "lessons-slug___el"
  }, {
    path: "/el/pay/:slug/",
    component: _39e5d60a,
    pathToRegexpOptions: {"strict":true},
    name: "pay-slug___el"
  }, {
    path: "/el/projects/:slug/",
    component: _08c2f0c7,
    pathToRegexpOptions: {"strict":true},
    name: "projects-slug___el"
  }, {
    path: "/es/classes/:classSlug/",
    component: _35dc2eed,
    pathToRegexpOptions: {"strict":true},
    name: "classes-classSlug___es"
  }, {
    path: "/es/invite/:code?/",
    component: _6aba546e,
    pathToRegexpOptions: {"strict":true},
    name: "invite-code___es"
  }, {
    path: "/es/lessons/:slug/",
    component: _237e53b4,
    pathToRegexpOptions: {"strict":true},
    name: "lessons-slug___es"
  }, {
    path: "/es/pay/:slug/",
    component: _39e5d60a,
    pathToRegexpOptions: {"strict":true},
    name: "pay-slug___es"
  }, {
    path: "/es/projects/:slug/",
    component: _08c2f0c7,
    pathToRegexpOptions: {"strict":true},
    name: "projects-slug___es"
  }, {
    path: "/fr/classes/:classSlug/",
    component: _35dc2eed,
    pathToRegexpOptions: {"strict":true},
    name: "classes-classSlug___fr"
  }, {
    path: "/fr/invite/:code?/",
    component: _6aba546e,
    pathToRegexpOptions: {"strict":true},
    name: "invite-code___fr"
  }, {
    path: "/fr/lessons/:slug/",
    component: _237e53b4,
    pathToRegexpOptions: {"strict":true},
    name: "lessons-slug___fr"
  }, {
    path: "/fr/pay/:slug/",
    component: _39e5d60a,
    pathToRegexpOptions: {"strict":true},
    name: "pay-slug___fr"
  }, {
    path: "/fr/projects/:slug/",
    component: _08c2f0c7,
    pathToRegexpOptions: {"strict":true},
    name: "projects-slug___fr"
  }, {
    path: "/it/classes/:classSlug/",
    component: _35dc2eed,
    pathToRegexpOptions: {"strict":true},
    name: "classes-classSlug___it"
  }, {
    path: "/it/invite/:code?/",
    component: _6aba546e,
    pathToRegexpOptions: {"strict":true},
    name: "invite-code___it"
  }, {
    path: "/it/lessons/:slug/",
    component: _237e53b4,
    pathToRegexpOptions: {"strict":true},
    name: "lessons-slug___it"
  }, {
    path: "/it/pay/:slug/",
    component: _39e5d60a,
    pathToRegexpOptions: {"strict":true},
    name: "pay-slug___it"
  }, {
    path: "/it/projects/:slug/",
    component: _08c2f0c7,
    pathToRegexpOptions: {"strict":true},
    name: "projects-slug___it"
  }, {
    path: "/lessons/edit/:slug/",
    component: _e5a86b2c,
    pathToRegexpOptions: {"strict":true},
    name: "lessons-edit-slug___en"
  }, {
    path: "/lessons/page/:page?/",
    component: _43edb2ae,
    pathToRegexpOptions: {"strict":true},
    name: "lessons-page-page___en"
  }, {
    path: "/lessons/select/:slug?/",
    component: _7780c890,
    pathToRegexpOptions: {"strict":true},
    name: "lessons-select-slug___en"
  }, {
    path: "/projects/page/:page?/",
    component: _f2e89de0,
    pathToRegexpOptions: {"strict":true},
    name: "projects-page-page___en"
  }, {
    path: "/pt_PT/classes/:classSlug/",
    component: _35dc2eed,
    pathToRegexpOptions: {"strict":true},
    name: "classes-classSlug___pt_PT"
  }, {
    path: "/pt_PT/invite/:code?/",
    component: _6aba546e,
    pathToRegexpOptions: {"strict":true},
    name: "invite-code___pt_PT"
  }, {
    path: "/pt_PT/lessons/:slug/",
    component: _237e53b4,
    pathToRegexpOptions: {"strict":true},
    name: "lessons-slug___pt_PT"
  }, {
    path: "/pt_PT/pay/:slug/",
    component: _39e5d60a,
    pathToRegexpOptions: {"strict":true},
    name: "pay-slug___pt_PT"
  }, {
    path: "/pt_PT/projects/:slug/",
    component: _08c2f0c7,
    pathToRegexpOptions: {"strict":true},
    name: "projects-slug___pt_PT"
  }, {
    path: "/studio/edit/:slug?/",
    component: _374897b5,
    pathToRegexpOptions: {"strict":true},
    name: "studio-edit-slug___en"
  }, {
    path: "/de/classes/:classSlug?/about/",
    component: _16245428,
    pathToRegexpOptions: {"strict":true},
    name: "classes-classSlug-about___de"
  }, {
    path: "/de/classes/:classSlug?/students/",
    component: _9dc62666,
    pathToRegexpOptions: {"strict":true},
    name: "classes-classSlug-students___de"
  }, {
    path: "/de/projects/:slug/embed/",
    component: _362c8964,
    pathToRegexpOptions: {"strict":true},
    name: "projects-slug-embed___de"
  }, {
    path: "/el/classes/:classSlug?/about/",
    component: _16245428,
    pathToRegexpOptions: {"strict":true},
    name: "classes-classSlug-about___el"
  }, {
    path: "/el/classes/:classSlug?/students/",
    component: _9dc62666,
    pathToRegexpOptions: {"strict":true},
    name: "classes-classSlug-students___el"
  }, {
    path: "/el/projects/:slug/embed/",
    component: _362c8964,
    pathToRegexpOptions: {"strict":true},
    name: "projects-slug-embed___el"
  }, {
    path: "/es/classes/:classSlug?/about/",
    component: _16245428,
    pathToRegexpOptions: {"strict":true},
    name: "classes-classSlug-about___es"
  }, {
    path: "/es/classes/:classSlug?/students/",
    component: _9dc62666,
    pathToRegexpOptions: {"strict":true},
    name: "classes-classSlug-students___es"
  }, {
    path: "/es/projects/:slug/embed/",
    component: _362c8964,
    pathToRegexpOptions: {"strict":true},
    name: "projects-slug-embed___es"
  }, {
    path: "/fr/classes/:classSlug?/about/",
    component: _16245428,
    pathToRegexpOptions: {"strict":true},
    name: "classes-classSlug-about___fr"
  }, {
    path: "/fr/classes/:classSlug?/students/",
    component: _9dc62666,
    pathToRegexpOptions: {"strict":true},
    name: "classes-classSlug-students___fr"
  }, {
    path: "/fr/projects/:slug/embed/",
    component: _362c8964,
    pathToRegexpOptions: {"strict":true},
    name: "projects-slug-embed___fr"
  }, {
    path: "/it/classes/:classSlug?/about/",
    component: _16245428,
    pathToRegexpOptions: {"strict":true},
    name: "classes-classSlug-about___it"
  }, {
    path: "/it/classes/:classSlug?/students/",
    component: _9dc62666,
    pathToRegexpOptions: {"strict":true},
    name: "classes-classSlug-students___it"
  }, {
    path: "/it/projects/:slug/embed/",
    component: _362c8964,
    pathToRegexpOptions: {"strict":true},
    name: "projects-slug-embed___it"
  }, {
    path: "/pt_PT/classes/:classSlug?/about/",
    component: _16245428,
    pathToRegexpOptions: {"strict":true},
    name: "classes-classSlug-about___pt_PT"
  }, {
    path: "/pt_PT/classes/:classSlug?/students/",
    component: _9dc62666,
    pathToRegexpOptions: {"strict":true},
    name: "classes-classSlug-students___pt_PT"
  }, {
    path: "/pt_PT/projects/:slug/embed/",
    component: _362c8964,
    pathToRegexpOptions: {"strict":true},
    name: "projects-slug-embed___pt_PT"
  }, {
    path: "/de/classes/:classSlug?/lessons/:slug?/",
    component: _496ac138,
    pathToRegexpOptions: {"strict":true},
    name: "classes-classSlug-lessons-slug___de"
  }, {
    path: "/el/classes/:classSlug?/lessons/:slug?/",
    component: _496ac138,
    pathToRegexpOptions: {"strict":true},
    name: "classes-classSlug-lessons-slug___el"
  }, {
    path: "/es/classes/:classSlug?/lessons/:slug?/",
    component: _496ac138,
    pathToRegexpOptions: {"strict":true},
    name: "classes-classSlug-lessons-slug___es"
  }, {
    path: "/fr/classes/:classSlug?/lessons/:slug?/",
    component: _496ac138,
    pathToRegexpOptions: {"strict":true},
    name: "classes-classSlug-lessons-slug___fr"
  }, {
    path: "/it/classes/:classSlug?/lessons/:slug?/",
    component: _496ac138,
    pathToRegexpOptions: {"strict":true},
    name: "classes-classSlug-lessons-slug___it"
  }, {
    path: "/pt_PT/classes/:classSlug?/lessons/:slug?/",
    component: _496ac138,
    pathToRegexpOptions: {"strict":true},
    name: "classes-classSlug-lessons-slug___pt_PT"
  }, {
    path: "/de/qr/:token?/:username?/",
    component: _cf118ff6,
    pathToRegexpOptions: {"strict":true},
    name: "qr-token-username___de"
  }, {
    path: "/el/qr/:token?/:username?/",
    component: _cf118ff6,
    pathToRegexpOptions: {"strict":true},
    name: "qr-token-username___el"
  }, {
    path: "/es/qr/:token?/:username?/",
    component: _cf118ff6,
    pathToRegexpOptions: {"strict":true},
    name: "qr-token-username___es"
  }, {
    path: "/fr/qr/:token?/:username?/",
    component: _cf118ff6,
    pathToRegexpOptions: {"strict":true},
    name: "qr-token-username___fr"
  }, {
    path: "/it/qr/:token?/:username?/",
    component: _cf118ff6,
    pathToRegexpOptions: {"strict":true},
    name: "qr-token-username___it"
  }, {
    path: "/pt_PT/qr/:token?/:username?/",
    component: _cf118ff6,
    pathToRegexpOptions: {"strict":true},
    name: "qr-token-username___pt_PT"
  }, {
    path: "/classes/:classSlug/",
    component: _35dc2eed,
    pathToRegexpOptions: {"strict":true},
    name: "classes-classSlug___en"
  }, {
    path: "/de/:username/",
    component: _44533d82,
    pathToRegexpOptions: {"strict":true},
    name: "username___de"
  }, {
    path: "/el/:username/",
    component: _44533d82,
    pathToRegexpOptions: {"strict":true},
    name: "username___el"
  }, {
    path: "/es/:username/",
    component: _44533d82,
    pathToRegexpOptions: {"strict":true},
    name: "username___es"
  }, {
    path: "/fr/:username/",
    component: _44533d82,
    pathToRegexpOptions: {"strict":true},
    name: "username___fr"
  }, {
    path: "/invite/:code?/",
    component: _6aba546e,
    pathToRegexpOptions: {"strict":true},
    name: "invite-code___en"
  }, {
    path: "/it/:username/",
    component: _44533d82,
    pathToRegexpOptions: {"strict":true},
    name: "username___it"
  }, {
    path: "/lessons/:slug/",
    component: _237e53b4,
    pathToRegexpOptions: {"strict":true},
    name: "lessons-slug___en"
  }, {
    path: "/pay/:slug/",
    component: _39e5d60a,
    pathToRegexpOptions: {"strict":true},
    name: "pay-slug___en"
  }, {
    path: "/projects/:slug/",
    component: _08c2f0c7,
    pathToRegexpOptions: {"strict":true},
    name: "projects-slug___en"
  }, {
    path: "/pt_PT/:username/",
    component: _44533d82,
    pathToRegexpOptions: {"strict":true},
    name: "username___pt_PT"
  }, {
    path: "/classes/:classSlug?/about/",
    component: _16245428,
    pathToRegexpOptions: {"strict":true},
    name: "classes-classSlug-about___en"
  }, {
    path: "/classes/:classSlug?/students/",
    component: _9dc62666,
    pathToRegexpOptions: {"strict":true},
    name: "classes-classSlug-students___en"
  }, {
    path: "/de/:username/about/",
    component: _249b62bd,
    pathToRegexpOptions: {"strict":true},
    name: "username-about___de"
  }, {
    path: "/de/:username/stories/",
    component: _1ed732fa,
    pathToRegexpOptions: {"strict":true},
    name: "username-stories___de"
  }, {
    path: "/el/:username/about/",
    component: _249b62bd,
    pathToRegexpOptions: {"strict":true},
    name: "username-about___el"
  }, {
    path: "/el/:username/stories/",
    component: _1ed732fa,
    pathToRegexpOptions: {"strict":true},
    name: "username-stories___el"
  }, {
    path: "/es/:username/about/",
    component: _249b62bd,
    pathToRegexpOptions: {"strict":true},
    name: "username-about___es"
  }, {
    path: "/es/:username/stories/",
    component: _1ed732fa,
    pathToRegexpOptions: {"strict":true},
    name: "username-stories___es"
  }, {
    path: "/fr/:username/about/",
    component: _249b62bd,
    pathToRegexpOptions: {"strict":true},
    name: "username-about___fr"
  }, {
    path: "/fr/:username/stories/",
    component: _1ed732fa,
    pathToRegexpOptions: {"strict":true},
    name: "username-stories___fr"
  }, {
    path: "/it/:username/about/",
    component: _249b62bd,
    pathToRegexpOptions: {"strict":true},
    name: "username-about___it"
  }, {
    path: "/it/:username/stories/",
    component: _1ed732fa,
    pathToRegexpOptions: {"strict":true},
    name: "username-stories___it"
  }, {
    path: "/projects/:slug/embed/",
    component: _362c8964,
    pathToRegexpOptions: {"strict":true},
    name: "projects-slug-embed___en"
  }, {
    path: "/pt_PT/:username/about/",
    component: _249b62bd,
    pathToRegexpOptions: {"strict":true},
    name: "username-about___pt_PT"
  }, {
    path: "/pt_PT/:username/stories/",
    component: _1ed732fa,
    pathToRegexpOptions: {"strict":true},
    name: "username-stories___pt_PT"
  }, {
    path: "/de/:username/art/%25_slug/",
    component: _664625d0,
    pathToRegexpOptions: {"strict":true},
    name: "username-art-%_slug___de"
  }, {
    path: "/de/:username/art/%25index/",
    component: _62d8e340,
    pathToRegexpOptions: {"strict":true},
    name: "username-art-%index___de"
  }, {
    path: "/el/:username/art/%25_slug/",
    component: _664625d0,
    pathToRegexpOptions: {"strict":true},
    name: "username-art-%_slug___el"
  }, {
    path: "/el/:username/art/%25index/",
    component: _62d8e340,
    pathToRegexpOptions: {"strict":true},
    name: "username-art-%index___el"
  }, {
    path: "/es/:username/art/%25_slug/",
    component: _664625d0,
    pathToRegexpOptions: {"strict":true},
    name: "username-art-%_slug___es"
  }, {
    path: "/es/:username/art/%25index/",
    component: _62d8e340,
    pathToRegexpOptions: {"strict":true},
    name: "username-art-%index___es"
  }, {
    path: "/fr/:username/art/%25_slug/",
    component: _664625d0,
    pathToRegexpOptions: {"strict":true},
    name: "username-art-%_slug___fr"
  }, {
    path: "/fr/:username/art/%25index/",
    component: _62d8e340,
    pathToRegexpOptions: {"strict":true},
    name: "username-art-%index___fr"
  }, {
    path: "/it/:username/art/%25_slug/",
    component: _664625d0,
    pathToRegexpOptions: {"strict":true},
    name: "username-art-%_slug___it"
  }, {
    path: "/it/:username/art/%25index/",
    component: _62d8e340,
    pathToRegexpOptions: {"strict":true},
    name: "username-art-%index___it"
  }, {
    path: "/pt_PT/:username/art/%25_slug/",
    component: _664625d0,
    pathToRegexpOptions: {"strict":true},
    name: "username-art-%_slug___pt_PT"
  }, {
    path: "/pt_PT/:username/art/%25index/",
    component: _62d8e340,
    pathToRegexpOptions: {"strict":true},
    name: "username-art-%index___pt_PT"
  }, {
    path: "/classes/:classSlug?/lessons/:slug?/",
    component: _496ac138,
    pathToRegexpOptions: {"strict":true},
    name: "classes-classSlug-lessons-slug___en"
  }, {
    path: "/qr/:token?/:username?/",
    component: _cf118ff6,
    pathToRegexpOptions: {"strict":true},
    name: "qr-token-username___en"
  }, {
    path: "/",
    component: _1c253ec6,
    pathToRegexpOptions: {"strict":true},
    name: "index___en"
  }, {
    path: "/:username/",
    component: _44533d82,
    pathToRegexpOptions: {"strict":true},
    name: "username___en"
  }, {
    path: "/:username/about/",
    component: _249b62bd,
    pathToRegexpOptions: {"strict":true},
    name: "username-about___en"
  }, {
    path: "/:username/stories/",
    component: _1ed732fa,
    pathToRegexpOptions: {"strict":true},
    name: "username-stories___en"
  }, {
    path: "/:username/art/%25_slug/",
    component: _664625d0,
    pathToRegexpOptions: {"strict":true},
    name: "username-art-%_slug___en"
  }, {
    path: "/:username/art/%25index/",
    component: _62d8e340,
    pathToRegexpOptions: {"strict":true},
    name: "username-art-%index___en"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
